// Descriptions checked against the public United Ad and LinkFlow landing pages.
// Keep service URLs here so a domain change only needs one update.
export const OUR_SERVICES = [
  {
    id: 'united-ad',
    number: '01',
    name: 'United Ad',
    category: '광고 및 판매',
    eyebrow: 'ADVERTISING & COMMERCE',
    headline: '광고의 시작,\n팀의 연결부터.',
    description: '팀, 광고 자산, 스마트스토어를 하나의 업무 공간으로. 브랜드별 워크스페이스에서 팀원과 함께 광고와 판매 채널을 관리하세요.',
    summary: '팀과 광고 자산, 판매 채널을 연결하는 광고·판매 운영 워크스페이스.',
    tags: ['팀 워크스페이스', 'Meta 연동', '스마트스토어 연동'],
    features: [
      { title: '브랜드별 워크스페이스', description: '브랜드와 프로젝트별로 업무 공간을 나누고, 이메일로 팀원을 초대해 역할을 관리합니다.' },
      { title: '팀의 광고 자산을 한곳에', description: 'Meta 광고 계정, Facebook 페이지, Instagram 프로필을 연결해 팀이 함께 사용할 자산을 확인합니다.' },
      { title: '판매 채널까지 연결', description: '네이버 스마트스토어를 연결해 상품과 판매 운영을 광고 업무와 함께 관리합니다.' },
    ],
    workflow: ['워크스페이스 만들기', '팀원 초대하기', '광고·판매 채널 연결'],
    url: 'https://united-ad.duckdns.org/',
    domainNotice: null,
    previewImage: '/images/services/united-ad.png',
  },
  {
    id: 'linkflow',
    number: '02',
    name: 'LinkFlow',
    category: '물품 생산 및 유통',
    eyebrow: 'MANUFACTURING & DISTRIBUTION',
    headline: '제조 의뢰부터 납품까지,\n하나의 흐름으로.',
    description: '제조사를 찾고, 견적을 비교하고, 생산·납품 일정을 맞추는 일. 구매·유통 기업과 제조 기업의 업무를 하나의 워크스페이스에서 연결하세요.',
    summary: '제조 의뢰, 제조사 매칭, 견적 비교부터 생산·납품까지 연결하는 B2B 워크스페이스.',
    tags: ['제조사 매칭', '견적 비교', '생산·납품 일정'],
    features: [
      { title: '제품 조건에 맞는 제조사 매칭', description: '제품 사양, 수량, 희망 납기를 정리하고 공정·인증·최소 주문량 등 조건에 맞는 제조사를 찾습니다.' },
      { title: '견적을 비교하고 주문으로', description: '단가와 배송비, 세금, 납기 조건을 비교합니다. 선택한 견적은 제조사의 수락을 거쳐 주문으로 이어집니다.' },
      { title: '생산부터 납품까지 일정 관리', description: '샘플·승인·생산·검수·출고·납품 단계를 함께 확인하고, 일정 변경이 다음 단계에 미치는 영향을 살펴봅니다.' },
    ],
    workflow: ['제조 의뢰', '제조사·견적 비교', '주문·생산·납품 관리'],
    url: 'https://linkflow.ai.kr/',
    domainNotice: null,
    previewImage: '/images/services/linkflow.png',
  },
];
